<template>
  <div class="content-wrap">
    <div class="main">
      <div class="container-fluid">
        <section id="main-content">
          <div id="mainSection">
            <div class="row">
              <div class="col-lg-6 tableReport1">
                <div class="card">
                  <div class="card-title pr d-flex" data-group="tableTitle">
                    <span>抓檔與KEY單數統計</span>
                    <div class="Calendar">
                      <div class="switch">
                        <input
                          type="radio"
                          class="switch-input"
                          name="tableReport1Timer"
                          value="month"
                          id="tableReport1Input-1"
                          v-model="tableReport1.mode"
                          @change="getTableReport1Prev"
                        />
                        <label for="tableReport1Input-1" class="switch-label switch-label-off">單月</label>
                        <input
                          type="radio"
                          class="switch-input"
                          name="tableReport1Timer"
                          value="date"
                          id="tableReport1Input-2"
                          v-model="tableReport1.mode"
                          checked
                          @change="getTableReport1Prev"
                        />
                        <label for="tableReport1Input-2" class="switch-label switch-label-on">單日</label>
                        <span class="slider"></span>
                      </div>
                      <div
                        class="form-check form-check-inline tableReport1Timer"
                        data-val="month"
                        v-if="tableReport1.mode == 'month'"
                      >
                        <select
                          class="form-control calendarSel"
                          v-model="tableReport1.sel"
                          @change="getTableReport1Prev"
                        >
                          <option
                            :value="String(mon).padStart(2,0)"
                            v-for="mon in 12"
                            :key="mon"
                          >{{mon}} 月</option>
                        </select>
                      </div>
                      <div
                        class="form-check form-check-inline tableReport1Timer"
                        data-val="date"
                        v-if="tableReport1.mode == 'date'"
                      >
                        <input
                          type="date"
                          class="form-control calendarInput"
                          v-model="tableReport1.input"
                          @change="getTableReport1Prev"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div>
                      <div class="bootstrap-data-table-panel">
                        <div class="table-responsive">
                          <table id="ftpAndKeyinTable" class="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>姓名</th>
                                <th>Ftp抓檔</th>
                                <th>總Key單數</th>
                                <th style="color:#007bff">線下審稿</th>
                                <th style="color:#28a745">Web審稿</th>
                                <th>web審稿-多款</th>
                                <th class="text-danger">錯誤件數</th>
                                <th class="text-danger">錯誤金額</th>
                                <th>百分比</th>
                                <th>審稿金額</th>
                              </tr>
                            </thead>
                            <tbody v-if="table1.length > 0">
                              <tr v-for="el in table1" :key="el.name">
                                <td>{{el.name}}</td>
                                <td class="text-dark">{{el.ftp}}</td>
                                <td class="text-dark" data-type="total">{{el.vol}}</td>
                                <td data-type="E" style="color:#007bff">{{el.offline}}</td>
                                <td data-type="W" style="color:#28a745">{{el.web}}</td>
                                <td class="text-dark">{{el.multiCount}}</td>
                                <td class="text-danger">{{el.wrongCs}}</td>
                                <td class="text-danger">{{el.wrongCost}}</td>
                                <td data-type="per">
                                  <div class="progress">
                                    <div
                                      class="progress-bar"
                                      :style="'width: '+el.Eper+'%;color:black'"
                                    ></div>
                                    <div
                                      class="progress-bar bg-success"
                                      :style="'width: '+el.Wper+'%'"
                                    ></div>
                                    <div
                                      class="progress-bar"
                                      style="padding-left:10px;color:#007bff;background-color:transparent;"
                                    >
                                      {{
                                      el.Eper == '0.00' ? '0%' : el.Eper + '%'
                                      }} /
                                    </div>
                                    <div
                                      class="progress-bar"
                                      style="color:#28a745;background-color:transparent;"
                                    >
                                      {{
                                      el.Wper == '0.00' ? '0%' : el.Wper + '%'
                                      }}
                                    </div>
                                  </div>
                                </td>
                                <td class="text-dark">{{el.money}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 tableReport2">
                <div class="card">
                  <div class="card-title pr d-flex" data-group="tableTitle">
                    <span>每小時審稿人件數表</span>
                    <div class="Calendar">
                      <div class="switch">
                        <input
                          type="radio"
                          class="switch-input"
                          name="tableReport2Timer"
                          id="tableReport2Input-1"
                          value="month"
                          v-model="tableReport2.mode"
                          @change="getReportTime(1)"
                        />
                        <label for="tableReport2Input-1" class="switch-label switch-label-off">單月</label>
                        <input
                          type="radio"
                          class="switch-input"
                          name="tableReport2Timer"
                          id="tableReport2Input-2"
                          value="date"
                          v-model="tableReport2.mode"
                          checked
                          @change="getReportTime(1)"
                        />
                        <label for="tableReport2Input-2" class="switch-label switch-label-on">單日</label>
                        <span class="slider"></span>
                      </div>
                      <div
                        class="form-check form-check-inline tableReport2Timer"
                        data-val="month"
                        v-if="tableReport2.mode=='month'"
                      >
                        <select
                          class="form-control calendarSel"
                          v-model="tableReport2.sel"
                          @change="getReportTime(1)"
                        >
                          <option
                            :value="String(mon).padStart(2,0)"
                            v-for="mon in 12"
                            :key="mon"
                          >{{mon}} 月</option>
                        </select>
                      </div>
                      <div
                        class="form-check form-check-inline tableReport2Timer"
                        data-val="date"
                        v-if="tableReport2.mode=='date'"
                      >
                        <input
                          type="date"
                          class="form-control calendarInput"
                          v-model="tableReport2.input"
                          @change="getReportTime(1)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div>
                      <div class="bootstrap-data-table-panel">
                        <div class="table-responsive">
                          <table id="PersonKeyinTable" class="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>姓名</th>
                                <th v-for="item in table2Head" :key="item">{{item}}</th>
                                <th>平均</th>
                              </tr>
                            </thead>
                            <tbody v-if="table2.length > 0">
                              <tr v-for="el in table2" :key="el.name">
                                <td class="text-dark">{{el.name}}</td>
                                <td class="text-dark" v-for="(data,i) in el.data" :key="i">{{data}}</td>
                                <td class="text-dark">{{el.avg}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 tableReport3">
                <div class="card">
                  <div class="card-title pr d-flex" data-group="tableTitle">
                    <span>Web審稿退線下率</span>
                    <div class="Calendar">
                      <div class="switch">
                        <input
                          type="radio"
                          class="switch-input"
                          name="tableReport3Timer"
                          id="tableReport3Input-1"
                          value="month"
                          v-model="tableReport3.mode"
                          @change="getReportTime(0)"
                        />
                        <label for="tableReport3Input-1" class="switch-label switch-label-off">單月</label>
                        <input
                          type="radio"
                          class="switch-input"
                          name="tableReport3Timer"
                          id="tableReport3Input-2"
                          value="date"
                          v-model="tableReport3.mode"
                          @change="getReportTime(0)"
                        />
                        <label for="tableReport3Input-2" class="switch-label switch-label-on">單日</label>
                        <span class="slider"></span>
                      </div>
                      <div
                        class="form-check form-check-inline tableReport3Timer"
                        data-val="month"
                        v-if="tableReport3.mode=='month'"
                      >
                        <select
                          class="form-control calendarSel"
                          v-model="tableReport3.sel"
                          @change="getReportTime(0)"
                        >
                          <option
                            :value="String(mon).padStart(2,0)"
                            v-for="mon in 12"
                            :key="mon"
                          >{{mon}} 月</option>
                        </select>
                      </div>
                      <div
                        class="form-check form-check-inline tableReport3Timer"
                        data-val="date"
                        v-if="tableReport3.mode=='date'"
                      >
                        <input
                          type="date"
                          class="form-control calendarInput"
                          v-model="tableReport3.input"
                          @change="getReportTime(0)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div>
                      <div class="bootstrap-data-table-panel">
                        <div class="table-responsive">
                          <table id="WebfailCodeTable" class="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>姓名</th>
                                <th>抓擋件數</th>
                                <th>退線下件數</th>
                                <th>退線下率</th>
                              </tr>
                            </thead>
                            <tbody v-if="table3.length > 0">
                              <tr v-for="el in table3" :key="el.name">
                                <td>{{el.name}}</td>
                                <td class="text-dark">{{el.files}}</td>
                                <td class="text-dark">{{el.failcs}}</td>
                                <td class="text-dark">{{el.failrate}}%</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/js/lib/data-table/jquery.dataTables.min.js';
import '../../assets/js/lib/data-table/dataTables.buttons.min.js';
import '../../assets/js/lib/data-table/buttons.flash.min.js';
import '../../assets/js/lib/data-table/jszip.min.js';
import 'pdfmake';
import '../../assets/js/lib/data-table/vfs_fonts.js';
import '../../assets/js/lib/data-table/buttons.html5.min.js';
import '../../assets/js/lib/data-table/buttons.print.min.js';

export default {
  data() {
    return {
      mainDep: '',
      nameList: [],
      tableReport1: {
        mode: 'date',
        input: '',
        sel: '',
        handler: {
          ReportPage2ExecReq: ''
        },
        mainData: []
      },
      tableReport2: {
        mode: 'date',
        input: '',
        sel: '',
        handler: {
          keyinReportExecReq: ''
        },
        hrAry: [],
        mainData: []
      },
      tableReport3: {
        mode: 'date',
        input: '',
        sel: '',
        handler: {
          webfailReportExecReq: ''
        },
        mainData: []
      }
    };
  },
  props: {
    time: {
      type: Object,
      required: true
    },
    mainColorObj: {
      type: Object,
      required: true
    }
  },
  created() {
    this.mainDep = this.$route.params.dep;
    $.ajax({
      url: './php/main.php',
      type: 'post',
      data: { function: 'getDepNameList', dep: this.mainDep }
    }).done(res => {
      const jsonData = JSON.parse(res);
      this.nameList = jsonData;
      this.tableReport1.input = this.time.today;
      this.tableReport1.sel = this.$formatTime(this.time.month);
      this.tableReport2.input = this.time.today;
      this.tableReport2.sel = this.$formatTime(this.time.month);
      this.tableReport3.input = this.time.today;
      this.tableReport3.sel = this.$formatTime(this.time.month);

      (async () => {
        await this.getTableReport1Prev();
        await this.getReportTime(1);
        await this.getReportTime(2);
      })();
    });
  },
  computed: {
    table1() {
      if (this.tableReport1.mainData.length === 0) return [];
      let Str = '',
        sum = 0,
        jsonData = this.tableReport1.mainData;
      let newAry = this.nameList.map(el => {        
        let ftp = jsonData[el.id] ? jsonData[el.id].ftp : 0,
          vol = jsonData[el.id] ? jsonData[el.id].total:0,
          money = jsonData[el.id] ?
            jsonData[el.id].offlineMoney * 1 + jsonData[el.id].webMoney * 1:0,
          web = jsonData[el.id] ?jsonData[el.id].web:0,
          offline = jsonData[el.id] ?jsonData[el.id].offline:0,
          wrongCs = jsonData[el.id] ?jsonData[el.id].wrongCs:0,
          wrongCost = jsonData[el.id] ?jsonData[el.id].wrongCost:0,
          multiCount = jsonData[el.id] ?jsonData[el.id].multiCount:0;
        sum += vol;
        money = Math.floor(money)
          .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
          .slice(0, -3);
        let obj = {
          ftp,
          vol,
          money,
          web,
          offline,
          wrongCs,
          wrongCost,
          name: el.name,
          multiCount
        };
        return obj;
      });
      newAry.forEach(el => {
        let Eper = sum !== 0 ? (((el.offline - 0) / sum) * 100).toFixed(2) : 0;
        let Wper = sum !== 0 ? (((el.web - 0) / sum) * 100).toFixed(2) : 0;
        el.Eper = Eper;
        el.Wper = Wper;
      });
      return newAry;
    },
    table2Head() {
      return this.tableReport2.hrAry;
    },
    table2() {
      if (this.tableReport2.mainData.length === 0) return [];
      return this.tableReport2.mainData;
    },
    table3() {
      if (this.tableReport3.mainData.length === 0) return [];
      return this.nameList.map(el => {
        let obj = {};
        let name = el.name.split('').filter(item => item.codePointAt() > 90).join('');
        let files = 0,
          failcs = 0,
          failrate = 0;
        if (this.tableReport3.mainData && this.tableReport3.mainData[el.id]) {
          files = this.tableReport3.mainData[el.id]['60'];
          failcs = this.tableReport3.mainData[el.id]['61'];
          failrate = (this.tableReport3.mainData[el.id]['62'] * 100).toFixed(2);
        }
        obj = {name,files, failcs, failrate};
        return obj;
      });
    }
  },
  methods: {
    getTableReport1Prev() {
      if (this.tableReport1.handler.ReportPage2ExecReq != '') {
        this.tableReport1.handler.ReportPage2ExecReq.abort();
      }

      const mode = this.tableReport1.mode;
      const inputMon = this.tableReport1.sel;
      const inputDate = this.tableReport1.input;
      let curDate = '',
        StartDate = '',
        EndDate = '',
        dateAry = '';
      if (mode == 'date') curDate = new Date(inputDate);
      if (mode == 'month')
        curDate = new Date(`${this.time.year}-${inputMon}-01`);
      let Ndate = curDate.getDate();
      let Nmonth = curDate.getMonth() + 1;
      let Nyear = curDate.getFullYear();
      let weekday = curDate.getDay(); //星期幾
      let Ndays = new Date(this.time.year, Nmonth, 0).getDate();

      if (mode == 'date') {
        StartDate = `${Nyear}-${this.$formatTime(Nmonth)}-${this.$formatTime(Ndate)}`;
        if (Ndate + 1 > Ndays) {
          Ndate = '01';
          if (Nmonth + 1 > 12) {
            Nmonth = '01';
            Nyear++;
          } else {
            Nmonth = this.$formatTime(Nmonth + 1);
          }
        } else {
          Ndate = this.$formatTime(Ndate + 1);
        }

        EndDate = `${Nyear}-${this.$formatTime(Nmonth)}-${this.$formatTime(Ndate)}`;
        dateAry = `${StartDate}@${EndDate}`;
      }
      if (mode == 'month') {
        StartDate = `${Nyear}-${this.$formatTime(Nmonth)}-01`;
        EndDate = `${Nyear}-${this.$formatTime(Nmonth)}-${Ndays}`;
        dateAry = `${StartDate}@${EndDate}`;
      }
      this.getTableReportData(dateAry);
    },
    getTableReportData(dateAry) {
      this.tableReport1.handler.ReportPage2ExecReq = $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'ReportPage2Exec2',
          dateAry: dateAry,
          dep: this.mainDep
        }
      }).done(res => {
        const jsonData = JSON.parse(res);
        this.tableReport1.mainData = jsonData;
        this.$nextTick(function() {
          this.renderReportTable_1();
        });
      });
    },
    renderReportTable_1() {
      let dataTableObj = {
        domID: '#ftpAndKeyinTable',
        Colums: [0],
        Orders: [8, 'desc'],
        destroyTrigger: [
          '.tableReport1 input[name="tableReport1Timer"]@click',
          '.tableReport1 .calendarSel@change',
          '.tableReport1 .calendarInput@change'
        ]
      };
      UseDataTablePlugin(dataTableObj);
    },
    getReportTime(type) {
      if (type === 1) {
        this.tableReport2.handler.keyinReportExecReq !== ''
          ? this.tableReport2.handler.keyinReportExecReq.abort()
          : '';
      } else {
        this.tableReport3.handler.webfailReportExecReq !== ''
          ? this.tableReport3.handler.webfailReportExecReq.abort()
          : '';
      }

      let mode = type === 1 ? this.tableReport2.mode : this.tableReport3.mode;
      let inputMon = type === 1 ? this.tableReport2.sel : this.tableReport3.sel;
      let inputDate =
        type === 1 ? this.tableReport2.input : this.tableReport3.input;
      let StartDate = '',
        EndDate = '',
        curDate = '';
      if (mode == 'date') {
        curDate = new Date(inputDate);
        StartDate = `${curDate.getFullYear()}-${this.$formatTime(curDate.getMonth() + 1)}-${this.$formatTime(curDate.getDate())}`;
        curDate = new Date(curDate.getTime() + 1000 * 60 * 60 * 24);
        EndDate = StartDate;
      }

      if (mode == 'month') {
        curDate = new Date();
        curDate.setMonth(inputMon);
        curDate.setDate(0);
        EndDate = `${curDate.getFullYear()}-${this.$formatTime(curDate.getMonth() + 1)}-${this.$formatTime(curDate.getDate())}`;

        curDate.setMonth(inputMon - 1);
        curDate.setDate(1);
        StartDate = `${curDate.getFullYear()}-${this.$formatTime(curDate.getMonth() + 1)}-${this.$formatTime(curDate.getDate())}`;
      }
      let dateStr = `${StartDate}@${EndDate}`;
      type === 1
        ? this.keyinPersonReportExec1(dateStr)
        : this.webFailReportExec(dateStr);
    },
    keyinPersonReportExec1(dateStr) {
      this.tableReport2.hrAry = [];
      this.tableReport2.mainData = [];
      this.tableReport2.handler.keyinReportExecReq = $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'SetKeyinReportTable2',
          dep: this.mainDep,
          date: dateStr
        }
      }).done(res => {
        let hrAry = JSON.parse(res);
        if (hrAry.length == 0) {
          this.tableReport2.hrAry = [];
        }
        if (hrAry.length > 0) {
          let ary_Hr = hrAry.reduce((prev, next) => {
            let hr = next.hourTime.split('>>')[1];
            prev.indexOf(hr) === -1 ? prev.push(hr) : '';
            return prev;
          }, []);

          this.tableReport2.hrAry = sortHr(ary_Hr);
        }
        this.keyinPersonReportExec2(dateStr);
      });
    },
    renderTable2() {
      // let Colums = [];
      // for (let i = 0; i < this.tableReport2.hrAry.length + 2; i++) {
      //   Colums.push(i);
      // }
      let dataTableObj = {
        domID: '#PersonKeyinTable',
        // Colums: Colums,
        Orders: [`${String(this.tableReport2.hrAry.length + 1)}`, 'desc'],
        destroyTrigger: [
          '.tableReport2 input[name="tableReport2Timer"]@click',
          '.tableReport2 .calendarSel@change',
          '.tableReport2 .calendarInput@change'
        ]
      };
      UseDataTablePlugin(dataTableObj);
    },
    keyinPersonReportExec2(dateStr) {
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'getKeyinReportData2',
          dep: this.mainDep,
          date: dateStr
        }
      }).done(res => {
        const data = JSON.parse(res);
        if (this.tableReport2.hrAry.length !== 0) {
          this.tableReport2.mainData = this.nameList.map(el => {
            let id = el.id;
            let sum = 0,
              count = 0,
              obj = { id, data: [], name: el.name };
            if (data[id]) {
              this.tableReport2.hrAry.forEach(hrStr => {
                let time = hrStr;
                if (data[id][time]) {
                  obj.data.push(data[id][time] * 1);
                  sum += data[id][time] * 1;
                  count++;
                } else {
                  obj.data.push(0);
                }
              });
              obj.avg = Math.ceil((sum / count).toFixed(2)) || 0;
            }
            return obj;
          });
          this.$nextTick(function() {
            this.renderTable2();
          });
        } else {
          this.renderTable2();
        }
      });
    },
    webFailReportExec(dateStr) {
      this.tableReport3.handler.webfailReportExecReq = $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'SetWebfailReportTable2',
          date: dateStr,
          dep: this.mainDep
        }
      }).done(res => {
        let jsonData = JSON.parse(res);
        this.tableReport3.mainData = jsonData;
        this.$nextTick(function() {
          this.renderTable3();
        });
      });
    },
    renderTable3() {
      let dataTableObj = {
        domID: '#WebfailCodeTable',
        Colums: [0],
        Orders: ['3', 'desc'],
        destroyTrigger: [
          '.tableReport3 input[name="tableReport3Timer"]@click',
          '.tableReport3 .calendarSel@change',
          '.tableReport3 .calendarInput@change'
        ]
      };
      UseDataTablePlugin(dataTableObj);
    }
  }
};

function UseDataTablePlugin(Obj) {
  let table = $(`${Obj.domID}`).DataTable({
    dom: 'Bfrtip',
    lengthMenu: [[25, 50, -1], [25, 50, 'All']],
    columnDefs: [
      {
        targets: Obj.Colums,
        render(data, type, row) {
          let color = 'black';
          return '<span style="color:' + color + '">' + data + '</span>';
        }
      }
    ],
    buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
    order: Obj.Orders,
    destroy: true,
    language: {
      emptyTable: '尚無資料',
      paginate: {
        previous: '上一頁',
        next: '下一頁'
      }
    },
    autoWidth: false,
    bInfo: false
  });
  Obj.destroyTrigger.forEach(el => {
    let dom = el.split('@')[0];
    let action = el.split('@')[1];
    $(`${dom}`).one(`${action}`, () => table.destroy());
  });
}

function sortHr(ary) {
  ary.sort((a, b) => {
    if (a >= 8 && b >= 8) return a - b;
    if (a < 8 && b < 8) return a - b;
    if (a >= 8 && b < 8) return -1;
  });
  return ary;
}
</script>

<style>
.dt-buttons {
  display: inline-block !important;
}
.dataTables_filter {
  float: right;
}

.dataTables_filter input[type='search'] {
  margin-left: 10px;
  box-shadow: none;
  border: 1px solid #e7e7e7;
  font-family: 'Roboto', sans-serif;
}

.dataTables_filter input[type='search']:focus {
  border: 1px solid #878787;
  border-radius: 10px;
  outline: none;
}
</style>